<template>
  <div>
      <blogs/>
  </div>
</template>

<script>
import Blogs from "@/components/blogs/Blogs";
export default {
components: {Blogs}
};
</script>

<style lang="scss" scoped>
</style>